export const ORDERS_PER_PAGE = {
  MOBILE: 10,
  TABLET: 8,
  DESKTOP: 14,
};
